<template>
  <div>
    <Header />
    <div class="content">
      <ContentMy v-if="current === 'my'" />
      <ContentInfo v-if="current === 'info'" :isShowCategory="true" />
      <ContentVideo v-if="current === 'video'" />
      <ContentLive v-if="current === 'live'" />
      <ContentRecommend v-if="current === 'recommend'" />
    </div>
    <Navigation  :current="current" @set-Current="setCurrent" />
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import Header from '@/components/header'
import Navigation from '@/components/navigation'
import ContentMy from '@/components/content/my'
import ContentInfo from '@/components/content/info'
import ContentVideo from '@/components/content/video'
import ContentLive from '@/components/content/live'
import ContentRecommend from '@/components/content/recommend'

export default {
  components: {
    Header,
    Navigation,
    ContentMy,
    ContentInfo,
    ContentVideo,
    ContentLive,
    ContentRecommend,
  },
  created(){
    if(this.$route.query.category){
      this.current = this.$route.query.category
    }
  },
  data(){
    return {
      current:'live',
    }
  },
  methods:{
    setCurrent(index){
      this.current = index
    },
  }
}
</script>

<style scope>
.content{
  margin: 3rem 0rem 3.5rem;
  height: 100%;
}
::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 0
}
::-webkit-scrollbar {
  width: 5px;
  height: 0px
}
::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #b8b8b8;
  -webkit-border-radius: 6px;
  outline-offset: -2px;
  filter: alpha(opacity = 50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  opacity: 0.5
}
::-webkit-scrollbar-thumb:hover {
  height: 50px;
  background-color: #878987;
  -webkit-border-radius: 6px
}
</style>
